export const pagination = {
  per_page: 50,
  page: 0,
  total_pages: 0,
  total_count: 0,
}

export const filters = {
  sort: 'created_at',
  order: 'asc',
  query: null,
  search_type: null
}

export function getPageUrl(url, pagination) {
  if(!url || url === '' || !pagination || !Object.keys(pagination).length) return console.error('Cannot form url for api call. Something is missing')
  if(!url.startsWith('/')) url = `/${url}`
  return url + Object.entries(pagination).map(([key, val], index) => `${!index ? '?' : ''}${key}=${val}`).join('&')
}

// This function forms query string for "NextPage" call
export function getNextPageUrl(url, pagination, currentFilters) {
  if(!url || url === '' || !pagination || !Object.keys(pagination).length) return console.error('Cannot form url for api call. Something is missing')
  if(!url.startsWith('/')) url = `/${url}`
  let paginationString = Object.entries(pagination).map(([key, val]) => `${key}=${ key === 'page' ? val + 1 : val}`).join('&')
  const filterString = Object.entries(currentFilters)
    .map(([key, val]) =>  {
      if(val === filters[key] || (Array.isArray(val) && val.length === 0)) return null;

      if(Array.isArray(val)) {
        let expandFilters = [];
        val.forEach(filter => {
          expandFilters.push(`${key}[]=${filter}`);
        })
        return expandFilters.join('&');
      }
      else {
        return `${key}=${val}`;
      }
    }).filter(item => item).join('&')
  if(filterString.length) paginationString = `${paginationString}&${filterString}`

  return `${url}?${paginationString}`
}